import AssociateTargetModal from './AssociateTargetModalPage';

export default AssociateTargetModal;
